import React from 'react'

import { addKeyToObjectsArray } from 'utils/addUniqueKeyToObjects'

import { reportError } from 'utils/errorReporter'
import styles from '../styles'

const BuildNegativeMedia = (props) => {
  const { negativeMediaData } = props
  const classes = styles()
  try {
    return negativeMediaData.links && negativeMediaData.links.length > 0 ? (
      <div className={classes.expansibleContent}>
        <span>Links relacionados:</span>
        <div style={{ padding: 5 }}>
          <ul>
            {
              addKeyToObjectsArray(negativeMediaData.links.map(link => { return { link: link } })).map((media_link) => {
                return (
                  <li key={media_link.key}>
                    <a
                      target="_blank"
                      href={media_link.link}
                      rel="noopener noreferrer"
                    >
                      {media_link.link}
                    </a>
                  </li>
                )
              })
            }
          </ul>
        </div>
      </div>
    ) : (
      <div className={classes.expansibleContent}>
        <span>Nenhum registro encontrado.</span>
      </div>
    )
  } catch (err) {
    reportError(err)
    return (
      <div className={classes.errorCaptured}>
        <span>Ocorreu um erro ao tratar os dados</span>
      </div>
    )
  }
}

export default BuildNegativeMedia
